import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    showErrorMessage, 
    showSuccessMessage, 
    showWarningMessage, 
    DefaultSettingsActionTypes,
    GET_MASTERDATABYNAME,
    SAVE_DEFAULT_TARGET_SETTINGS,
    GET_DEFAULT_TARGET_SETTINGS, 
} from '../constants/ApiConstants';

import Alert from 'react-s-alert';
import { checkHttpStatusAuthCheck, createSearchUrlForCustomAPI } from '../../../../../actions/utilAction';

export const getMasterData = (masterData) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DefaultSettingsActionTypes.get_masterData.REQUEST));
        fetch(`${GET_MASTERDATABYNAME}`, {
            method: 'post',
            body: JSON.stringify(masterData),
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
            .then(function (response) {
                dispatch(actionCreator(DefaultSettingsActionTypes.get_masterData.SUCCESS, response));
            })
            .catch(function (error) {
                console.log('error getMasterData ..', error);
            });
    };
};

export const SaveDefaultTargetSettingsData = (formProps) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(DefaultSettingsActionTypes.save_defaultTargetSettings.REQUEST));
      fetch(`${SAVE_DEFAULT_TARGET_SETTINGS}`, {
          method: 'POST',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
          body: JSON.stringify(formProps),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  showSuccessMessage(response.message);
                  dispatch(actionCreator(DefaultSettingsActionTypes.save_defaultTargetSettings.SUCCESS, response));                  
              } else {
                  showErrorMessage(response.message);
                  dispatch(actionCreator(DefaultSettingsActionTypes.save_defaultTargetSettings.SUCCESS, null));
              }
          })
          .catch(function (error) {
              console.log('error save_rawskillaquisitionbehaviordata', error);
          });
  };
};



export const getDefaultTargetSettingsData = () => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DefaultSettingsActionTypes.get_defaultTargetSettings.REQUEST));
        fetch(`${GET_DEFAULT_TARGET_SETTINGS}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DefaultSettingsActionTypes.get_defaultTargetSettings.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DefaultSettingsActionTypes.get_defaultTargetSettings.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_skillAcquisitionTargetDetail', error);
            });
    };
};


  


// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/defaultSettings/actions/defaultSettingsActions.js